import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'
import { routes } from './router/Routes'
import pt_BR from 'vee-validate/dist/locale/pt_BR'
import VeeValidate, { Validator } from 'vee-validate'
import Vue2Filters from 'vue2-filters'
import store from './vuex/store'
import 'es6-promise/auto'
import swal from 'sweetalert';
import '../static/css/swal.css';

/* FUNÇÃO PARA FECHAR MODAL NA FRENTE DO OUTRO */
import { fecharModal } from "./helpers/Formulario/Formulario";
fecharModal();

/* Vue Mask Input */
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask);

/* VeeValidator */
Vue.use(VeeValidate);
Validator.localize('pt_BR', pt_BR);

/* DEBUG VUEJS */
Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.config.performance = true;

/* VueAxios */
Vue.use(VueAxios, axios);

Vue.filter('integer', function (value) {
  if (!value) return ''
  return Math.floor(value) // Exemplo: arredonda para o número inteiro
})

let dominio = window.location.host;
if (dominio === "localhost:8090") {

    // axios.defaults.headers['Subdomain'] = 'dev';
    // Vue.axios.defaults.baseURL = 'http://www.api.com.br/index.php/';
    axios.defaults.headers['Subdomain'] = 'dev';
    Vue.axios.defaults.baseURL = 'http://localhost:8080/';
    //   Vue.axios.defaults.baseURL = 'https://ordesign.websysemp.com.br/api/';
} else {
    let subdominio = dominio.split('.');
    axios.defaults.headers['Subdomain'] = subdominio[0];

    // LINK DE PRODUÇÃO
    Vue.axios.defaults.baseURL = window.location.protocol + '//' + subdominio[0] + '.websysemp.com.br/api/';

    // CONFIGURAÇÃO E LINK DE TESTE PARA O FCSERVER
//    axios.defaults.headers['Subdomain'] = 'dev';
//    Vue.axios.defaults.baseURL = 'http://fcserver.fabricadecodigos.com.br:8080/';
}

/* VueRouter */
Vue.use(VueRouter);
const router = new VueRouter({
    routes,
    mode: 'history'
});

/* Vue2Filters */
Vue.use(Vue2Filters);

/* checkCookie Usuario e Parceiro */
import { CheckLocalStorage, GetLocalStorage } from './helpers/Storage/Storage'

router.beforeEach((to, from, next) => {

    /* Limpa mensagem de alerta que fica instanciado (Snotify)  */
    Vue.prototype.$snotify.clear();

    let validaSessao = false;
    if (CheckLocalStorage('Parceiro')) {
        validaSessao = true
    }
    if (CheckLocalStorage('Usuario')) {
        validaSessao = true
    }

    if (to.matched.some(record => record.meta.auth) && (validaSessao === false)) {
        next({ path: '/' })
    }
    next();
});


/* AGGRID VUEJS */
import 'ag-grid/dist/styles/ag-grid.css'
import 'ag-grid/dist/styles/ag-theme-material.css'
import 'ag-grid-enterprise/main'

/* SET VALIDAÇÃO USUARIO OU PARCEIRO
 * Campo Tipo Usuario no JSON Valida o tipo de Usuario
 * Usuario SysEmp = 1
 * Usuario B2B = 2
 * */
let validaUsuario = '';
if (CheckLocalStorage('Usuario')) {
    validaUsuario = GetLocalStorage('Usuario')
} else {
    validaUsuario = GetLocalStorage('Parceiro')
}
Vue.prototype.validaUsuario = validaUsuario;

/* VueMaterial */
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
Vue.use(VueMaterial);

/* SNOTIFY */
import Snotify from 'vue-snotify'
Vue.use(Snotify, {});
import 'vue-snotify/styles/material.css'

/* SelectMaterial */
import { materialselect } from "../src/components/Shared/Material/MaterialSelect"

/* VUE - KENDO UI - TELERIK */
import '@progress/kendo-ui'
import '../static/css/kendo/all-blue.css'
import { KendoDropdownsInstaller } from '@progress/kendo-dropdowns-vue-wrapper'


Vue.use(KendoDropdownsInstaller);

export const vue = new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js